/**
 *
 * @component 数据看板卡片
 * @prop {String} tabsProps.activeKey // 当前的tabkey
 * @prop {Function} tabsProps.onChange  //tab变化
 * @prop {ReactNode} headerExtra  // 卡片header右侧附加内容
 *
 **/

import { Tabs, Space } from 'antd';
import './BaseCard.scss';

function BaseCard(props) {
    const { title, tabs = [], headerExtra, tabsProps = {}, className } = props;

    return (
        <div className={`base-card-component ${className || ''}`}>
            <div className="card-header">
                <div className="card-header-content">
                    {title}
                    {!!tabs.length && (
                        <Tabs
                            {...tabsProps}
                            className="use-antd"
                            renderTabBar={(props, DefaultTabBar) => (
                                <DefaultTabBar
                                    {...props}
                                    className="use-antd-tab"
                                />
                            )}>
                            {tabs.map(({ name, key }) => (
                                <Tabs.TabPane tab={name} key={key} />
                            ))}
                        </Tabs>
                    )}

                    <Space>{headerExtra}</Space>
                </div>
            </div>
            <div className="card-body">{props.children}</div>
        </div>
    );
}

export default BaseCard;
